module.exports = __webpack_public_path__ + "img/fat_scale.090aa925.svg";